import { action, extendObservable } from 'mobx'
import { URL_GET_SUMMARY } from '../constants/index';
import axios from 'axios';

const Finance = require('financejs');

class SummaryData {

    constructor() {
        extendObservable(this, {
            loading: false,
            project: {},
            beginPrice: 0,
            plan: {},
            calculationFactor: {},
            homeAppliance: [],
            livingTime: {},
            optionalData: {},
            packages: [
                {
                    powerGeneration: 0
                }
            ], // solarCell
            info: [], // solarCell
            powerGenerationSelected: 0, // solarCell
            additionalSelected: 0, // solarCell
            defaultSolarPackageId: 0,
            idSelected: 1,
            idMaxPackage: null,
            ///  calculator
            costOfSolarPerKW: 45000,
            weekday: 0,
            weekend: 0,
            usePercent: 0,
            sumKW: 0,
            bathValue: 0,
            co2Value: 0,
            treeValue:0,
            //// Cal % Save Summary
            weekdayDefault: 12,
            weekendDefault: 12,
            eveningDefault: 5,
            percentSave: 0,
            resultSolarPerMonth: 0,
            //// Cal อัตราการผ่อน
            homeCostPerMonth: 0,
            solarCostPerMonth: 0,
            evCostPerMonth: 0,
            evCost: 120000,
            isEvSelect: false,
            year: 0,
            interest: 0,
            sumCost: 0,
            sumCostPerMonth: 0,
            //// use for summary Page ...
            subType: ''
        })
    }

    @action gotoDetailProject() {
        window.open(this.project.projectLinkUrl, "_blank")
    }

    @action resetInstalmentValue() {
        this.homeCostPerMonth = 0;
        this.solarCostPerMonth = 0;
        this.evCostPerMonth = 0;
    }

    @action setYearAndMonth(year,interest) {
        this.year = year;
        this.interest = interest;
    }

    @action calPerMonth(year, interest) {
        let finance = new Finance();
        this.year = year || this.year;
        this.interest = interest || this.interest;
        this.sumCost = this.plan.beginPrice || 0; // beginPrice + solar + ev
        if(this.year > 0 && this.interest > 0) {
            this.evCostPerMonth = 0;
            if(this.isEvSelect){
                this.evCostPerMonth = finance.AM(this.evCost, this.interest, this.year, 0);
                this.sumCost += this.evCost;
            }
            this.solarCostPerMonth = 0;
            if(this.defaultSolarPackageId !== this.idSelected) {
                this.solarCostPerMonth = finance.AM(this.calPriceOfSolar(this.powerGenerationSelected), this.interest, this.year, 0);
                this.sumCost += this.calPriceOfSolar(this.powerGenerationSelected);
            }
            this.homeCostPerMonth = finance.AM(this.plan.beginPrice, this.interest, this.year, 0) || 0;
            this.sumCostPerMonth = this.evCostPerMonth+this.solarCostPerMonth+this.homeCostPerMonth;
        }
    }

    @action setEVSelect(isSelect) {
        this.isEvSelect = !isSelect;
    }

    @action calPriceOfSolar(solarSelected) {
        let additionalPrice;
        this.packages.map((data)=> {
            if(solarSelected === data.powerGeneration) {
                additionalPrice = data.additionalPrice;
            }
            return true;
        });
        return additionalPrice;
    }

    // @action calPriceOfSolar(solarSelected) {
    //     let defaultSolar = this.packages[0].powerGeneration;
    //     let additionalPrice;
    //     let defaultPrice;
    //     let desPrice;
    //
    //     this.packages.map((data)=> {
    //
    //         if (data.powerGeneration === defaultSolar){
    //             defaultPrice = data.additionalPrice;
    //         }
    //
    //         if (data.powerGeneration === solarSelected){
    //             desPrice = data.additionalPrice;
    //         }
    //     });
    //     //additionalPrice = (solarSelected - defaultSolar) * this.costOfSolarPerKW;
    //     additionalPrice = desPrice - defaultPrice;
    //     return additionalPrice;
    // }

    @action calForShowSummary() {
        this.calSolarCellForKW();
        let hourDefault = this.calHourPerMonth(this.weekday, this.weekend, this.eveningDefault);
        let bathDefault = this.calculationFactor.electricityRate * hourDefault * this.sumKW * 12; // add * 12 : month --> year
        this.bathValue = this.calculationFactor.electricityRate * this.resultSolarPerMonth * 12; // add * 12 : month --> year
        this.co2Value = this.calculationFactor.co2 * (this.resultSolarPerMonth/28);
        this.treeValue = this.calculationFactor.tree * (this.resultSolarPerMonth/28);
        this.percentSave = this.format1(( this.bathValue/bathDefault)*100);
    }

    @action calSolarCellForKW() {
        // (weekday×totalKW×5+weekend×totalKW×2)×4÷3
        let totalKW = this.sumKW;
        if(totalKW > this.powerGenerationSelected) {
            totalKW = this.powerGenerationSelected;
        }
        this.resultSolarPerMonth = (((this.weekday*totalKW)*5)+((this.weekend*totalKW)*2))*4/3;
    }

    @action calHourPerMonth(weekday, weekend, evening = 0) {
        return ( ((weekday+evening)*5) + ((weekend+evening)*2) ) * 4;
    }

    @action
    format2(value) {
        var o = 0;
        o = parseFloat(value).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
        o = o.replace(".00",".00");
        return o.replace("-","");
    }
    @action
    format_(value) {
        return parseFloat(value).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    }
    @action
    format1(value) {
        var o = 0;
        o = parseFloat(value).toFixed(1).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
        o = o.replace(".00", ".00");
        return o.replace("-", "");
    }

    @action setHomeApplianceNumber(id,number) {
        this.homeAppliance[id].number = number;
        this.calHomeAppliance(); /// cal KW for use
        this.calForShowSummary();
    }

    @action calHomeAppliance() {
        this.sumKW = 0;
        this.homeAppliance.map((data)=> {
            this.sumKW += data.number*(data.powerConsume/1000);
            return false;
        });
        this.setPercentOfUse(this.sumKW,this.powerGenerationSelected);
    }

    @action setPercentOfUse(useValue,totalValue) {
        /// useValue เป็นกี่ % ของ totalValue;
        this.usePercent = (useValue/totalValue)*100;
    }

    @action
    changePackage(id){
        this.idSelected = id;
        this.info = [];
        this.packages.map((data) => {
            if(data.id === id){
                this.info = data.info;
                this.powerGenerationSelected = data.powerGeneration;
                this.additionalSelected = data.additionalPrice;
                return false;
            }
        })
        this.setPercentOfUse(this.sumKW,this.powerGenerationSelected);
        this.calForShowSummary();
        this.calPerMonth(this.year, this.interest);
    }
    @action
    setWeekdayHour(value) {
        this.weekday = value;
    }
    @action
    setWeekendHour(value) {
        this.weekend = value;
    }

    @action setSummaryData(data) {
        this.project = data.project;
        this.subType = data.project.projectType;
        // this.beginPrice = data.project.beginPrice; /// Each plan has many plans
        this.plan = data.plan;
        this.beginPrice = data.plan.beginPrice || 0; /// Each plan do not equal price
        this.calculationFactor = data.calculationFactor;
        /// applianceSet
        this.homeAppliance = data.homeAppliance;
        this.calHomeAppliance();
        this.livingTime = data.livingTime;
        this.optionalData = data.optionalData;
        this.packages = data.solarCell.packages;
        this.info = data.solarCell.packages[0].info;
        this.powerGenerationSelected = data.solarCell.packages[0].powerGeneration;
        this.additionalSelected = data.solarCell.packages[0].additionalPrice;
        this.defaultSolarPackageId = data.plan.defaultSolarPackageId;
        this.idSelected = data.plan.defaultSolarPackageId;
        this.idMaxPackage =this.packages[this.packages.length - 1].id;
        // livingTime
        this.weekday = data.livingTime.weekDayHour;
        this.weekend = data.livingTime.weekendHour;
        this.loading = false;
        this.setPercentOfUse(this.sumKW,this.powerGenerationSelected);
        this.calForShowSummary();
    }

    @action
    getSummary(prj,pln) {
        // console.log(URL_GET_SUMMARY+'?prj='+prj+'&pln='+pln);
        this.loading = true;
        let option = {
            method : "GET",
            url: URL_GET_SUMMARY+'?prj='+prj+'&pln='+pln,
            headers: {
                'Content-Type': 'application/json'
            }
        };

        axios(option)
            .then((res) => {
                // this._printLog('res :: ', res);
                if (res.status === 200) {
                    return res.data;
                }
            })
            .then((data) => {
                // console.log('getSummary : data :: ',data);
                this.setSummaryData(data.responseObject);
            })
            .catch((err) => {
                console.log(err)
            })
    }

}

export default SummaryData;


// WEBPACK FOOTER //
// ./src/stores/SummaryData.js